import { FormControl, FormGroup } from '@angular/forms';

import type { User } from '@core/account-types';

export enum RequestEvaluationDropdownContext {
  Default,
  Scheduler,
}

export type RequestEvaluationDropdownForm = FormGroup<{
  offerId: FormControl<number | null>;
  templateId: FormControl<number | null>;
  admins: FormControl<User[]>;
}>;

export interface EvaluationDueDateConfig {
  dueDateType: 'relative' | 'absolute';
  dueDateUnit: string | null;
  dueDateValue: string | null;
}

export type EvaluationSendAtKind = 'on_day_of_schedule' | 'on_day_of_event';

export interface RequestEvaluationSubmit {
  offerId?: number;
  talentPoolId?: number;
  templateId: number;
  admins: User[];
  dueDate?: string | null;
  dueDateConfig?: EvaluationDueDateConfig | null;
  sendAtKind?: EvaluationSendAtKind | null;
}
